import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Relatorios from "@/pages/Relatorios";
import ResumoExecutivo from "@/pages/ResumoExecutivo";
import RelatorioGerencial from "@/pages/RelatorioGerencial";
import Desempenho from "@/pages/Desempenho";
import RelatorioAvaliacoes from "@/pages/RelatorioAvaliacoes";

export default function RelatoriosHub() {
  const [sp, setSp] = useSearchParams();
  const { user } = useAuth();
  const managerish = ["admin", "director", "manager", "diretor_geral"].includes(user?.role);

  const tabs = useMemo(() => {
    const t = [
      { key: "comercial", label: "Comercial" },
      { key: "resumo", label: "Resumo executivo" },
      { key: "avaliacoes", label: "Avaliações" },
    ];
    if (managerish) {
      t.splice(1, 0, { key: "gerencial", label: "Gerencial" });
      t.push({ key: "desempenho", label: "Desempenho" });
    }
    return t;
  }, [managerish]);

  const active = tabs.find((t) => t.key === sp.get("tab"))?.key || tabs[0].key;

  const setActive = (val) => {
    const next = new URLSearchParams(sp);
    next.set("tab", val);
    setSp(next, { replace: false });
  };

  return (
    <div data-testid="relatorios-hub">
      <Tabs value={active} onValueChange={setActive}>
        {/* Item 3.9 — abas não podem sobrepor o título. Em telas estreitas
         * viram um scroller horizontal (uma linha só); em >=sm ficam inline. */}
        <div className="overflow-x-auto -mx-4 md:mx-0 md:overflow-visible mb-4">
          <TabsList className="w-max sm:w-auto flex sm:flex-wrap gap-1 px-4 md:px-0">
            {tabs.map((t) => (
              <TabsTrigger key={t.key} value={t.key} data-testid={`relatorios-tab-${t.key}`} className="whitespace-nowrap shrink-0">
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        <TabsContent value="comercial"><Relatorios /></TabsContent>
        <TabsContent value="resumo"><ResumoExecutivo /></TabsContent>
        <TabsContent value="avaliacoes"><RelatorioAvaliacoes /></TabsContent>
        {managerish && <TabsContent value="gerencial"><RelatorioGerencial /></TabsContent>}
        {managerish && <TabsContent value="desempenho"><Desempenho /></TabsContent>}
      </Tabs>
    </div>
  );
}
